import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ items = [], className = '' }) => {
  if (!items || items?.length === 0) return null;

  return (
    <nav className={`flex items-center space-x-1 text-sm text-muted-foreground ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {items?.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="mx-2 text-muted-foreground/60" />
            )}
            {item?.href && index < items?.length - 1 ? (
              <Link
                to={item?.href}
                className="hover:text-foreground transition-micro hover:underline"
              >
                {item?.label}
              </Link>
            ) : (
              <span className={index === items?.length - 1 ? 'text-foreground font-medium' : ''}>
                {item?.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;